import { Link, useNavigate } from "react-router-dom";
import { Alert, Button, Col, Row, Spinner } from "react-bootstrap";
import { useQuery } from "react-query";
import Icon from "@mdi/react";
import { mdiCardRemoveOutline, mdiChevronRight, mdiCogOutline, mdiBookCogOutline } from "@mdi/js";

import { ModuleEntity, ModulePermissionEntity, SkeletonCount } from "../../config/defines";
import { modulePermissionCheck } from "../../config/utils";
import { useToast } from "../../context/ToastContext";
import { useAuth } from "../../context/AuthContext";
import { QuestionnaireGetQuestionnairesResponse } from "../../entities/QuestionnaireEntity";
import QuestionnaireService from "../../services/QuestionnaireService";

import ConfiguracoesAvaliacaoCard from "../../components/ConfiguracoesAvaliacaoCard";
import Layout from "../../components/Layout";

const toastTitle = "Avaliações";

export default function ConfiguracoesAvaliacoes() {
	const questionnaireService = new QuestionnaireService();

	const navigate = useNavigate();
	const { user } = useAuth();
	useToast(toastTitle);

	const { data, isLoading, isRefetching, isError } = useQuery<QuestionnaireGetQuestionnairesResponse[]>(["avaliacoes"], () => fetchData());

	async function fetchData() {
		const resp = await questionnaireService.getQuestionnaires();
		return resp.data;
	}

	return (
		<Layout>
			<h5 className="mt-4 mb-4 d-flex align-items-center fw-light">
				<Link to={"/configuracoes"} className="d-flex text-decoration-none">
					<Icon path={mdiCogOutline} size={1} className="me-1" /> Configurações
				</Link>
				<Icon path={mdiChevronRight} size={1} className="ms-1 me-1" />
				<Icon path={mdiBookCogOutline} size={1} className="me-1" /> Avaliações
				{isRefetching && <Spinner size="sm" className="ms-1" variant="secondary" />}
				<div className="d-flex gap-2 float-right ms-auto" style={{ marginTop: -10, marginBottom: -10 }}>
					{modulePermissionCheck(user!, ModuleEntity.configuracoesAvaliacoes, ModulePermissionEntity.editar) && (
						<Button
							variant="primary"
							className="rounded-3 shadow-sm"
							onClick={() => {
								navigate("/avaliacaoConfiguracoes");
							}}
						>
							Cadastrar
						</Button>
					)}
				</div>
			</h5>

			<Row className="mb-4">
				{isLoading &&
					Array.from({ length: Number(SkeletonCount) }, (_, index) => {
						return (
							<Col md={12} key={index}>
								<ConfiguracoesAvaliacaoCard skeleton />
							</Col>
						);
					})}
				{!isLoading && isError && (
					<Col md={12}>
						<Alert variant="secondary" className="text-center">
							Problema na operação. Tente novamente mais tarde
						</Alert>
					</Col>
				)}
				{!isLoading && data && data.length === 0 && (
					<Col md={12}>
						<Alert variant="light" className="text-center p-4 d-flex justify-content-center align-items-center">
							<Icon path={mdiCardRemoveOutline} size={1} className="me-2" />
							Nenhum registro encontrado
						</Alert>
					</Col>
				)}
				{!isLoading &&
					data &&
					data.length >= 1 &&
					data.map((item) => {
						return (
							<Col md={12} key={item.id}>
								<ConfiguracoesAvaliacaoCard data={item} />
							</Col>
						);
					})}
			</Row>
		</Layout>
	);
}
